const appContainer = document.querySelector('#appContainer');

const urls = {
    polygon: appContainer.dataset.polygonUrl,
    marker: appContainer.dataset.markerUrl,
    relief: appContainer.dataset.reliefUrl,
    select2obceUrl: appContainer.dataset.selectObceUrl,
    audioUrl: appContainer.dataset.audioUrl,
};

export default urls;
